<template>
  <v-toolbar
    :class="{ primary: isMobile() }"
    :dark="isMobile()"
    :max-height="isMobile() ? 56 : 64"
    tile
    :style="{ 'z-index': 999 }"
  >
    <v-btn icon v-if="isMobile()" @click="$router.go(-1)"
      ><v-icon>mdi-arrow-left</v-icon></v-btn
    >
    <icone-visita-tecnica class="mr-3" v-else :icone="opcao_checklist.icone" />
    <!-- <v-icon v-else class="mr-3 primary--text">{{
      opcao_checklist.icone
    }}</v-icon> -->
    <v-toolbar-title
      :class="{ 'primary--text font-weight-bold': !isMobile() }"
      >{{ opcao_checklist.descricao }}</v-toolbar-title
    >
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn icon v-if="!isMobile()" @click="$router.go(-1)"
        ><v-icon>mdi-close</v-icon></v-btn
      >
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import IconeVisitaTecnica from "./IconeVisitaTecnica.vue";

export default {
  components: { IconeVisitaTecnica },
  props: {
    opcao_checklist: { type: Object, required: true },
  },
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>